import DOMPurify from 'dompurify';

// Wraps DOMPurify with a config permissive enough for admin-authored rich
// text (emails, service descriptions, form notes) while stripping script
// vectors (onerror=, <script>, javascript: URLs, etc).
export const sanitizeHtml = (html) => {
  if (!html) return '';
  return DOMPurify.sanitize(html, {
    ADD_TAGS: ['style'],
    ADD_ATTR: ['target'],
  });
};

export default sanitizeHtml;
